import React from 'react';
import classNames from 'classnames';
import { Link as GatsbyLink } from 'gatsby';

import SafeAnchor from '../SafeAnchor';
import { isExternalUrl } from '../../utils';

const ns = `link`;

const Link = React.forwardRef(
	(
		{
			className,
			disabled,
			variant,
			to,
			href,
			...props
		},
		ref
	) => {
		const rootClassnames = classNames({
			[`${ ns }`]: true,
			[`${ ns }--${ variant }`]: variant,
			[className]: className,
		});

		if (isExternalUrl(href) || isExternalUrl(to)) {
			return (
				<SafeAnchor
					{...props} // eslint-disable-line
					aria-label={props['aria-label'] || 'external-link'}
					disabled={disabled}
					href={href || to}
					ref={ref}
					target={'_blank'}
					className={classNames(rootClassnames)}
				/>
			);
		}

		if (disabled) {
			props.tabIndex = -1; // eslint-disable-line
			props['aria-disabled'] = true; // eslint-disable-line
		}

		if (!href && !to) {
			return (
				<span
					{...props}
					className={rootClassnames}
				/>
			);
		}

		return (
			<GatsbyLink
				{...props} // eslint-disable-line
				aria-label={props['aria-label'] || 'link'}
				disabled={disabled}
				to={to || href || '/'}
				ref={ref}
				className={rootClassnames}
			/>
		);
	}
);

Link.defaultProps = {
	disabled: false,
};

export default Link;
